/**
 * @name LoaderTransition
 * @author Keven Adan Bezerra | kevenadanb
 * @description Componente de transição para o loader, responsável por aplicar efeitos suaves de entrada e saída.
 * @returns {JSX.Element} - JSX do componente com transições.
 * @package src/components/common/loaders/LoaderTransition.tsx
 */

import { Fade } from "@mui/material";
import React, { useEffect, useState } from "react";
import LogoLoader from "./LogoLoader";

interface LoaderTransitionProps {
  isLoading: boolean;
  timeout?: number;
}

const LoaderTransition: React.FC<LoaderTransitionProps> = ({
  isLoading,
  timeout = 300,
}) => {
  const [showLoader, setShowLoader] = useState(false);
  const [mountLoader, setMountLoader] = useState(false);

  useEffect(() => {
    if (isLoading) {
      // Monta e mostra IMEDIATAMENTE para evitar tela branca
      setMountLoader(true);
      setShowLoader(true);
    } else {
      // Iniciar fade out suavemente
      setShowLoader(false);
      // Desmontar após a animação
      const hideTimer = setTimeout(() => {
        setMountLoader(false);
      }, timeout + 100); // Delay extra para transição suave
      return () => clearTimeout(hideTimer);
    }
  }, [isLoading, timeout]);

  if (!mountLoader) {
    return null;
  }
  return (
    <Fade
      in={showLoader}
      timeout={{
        enter: 0, // Entrada instantânea para evitar tela branca
        exit: timeout, // Saída suave após carregamento completo
      }}
      style={{
        transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)", // Material Design standard easing
      }}
    >
      <div>
        <LogoLoader />
      </div>
    </Fade>
  );
};

export default LoaderTransition;
